module.exports = __webpack_public_path__ + "353f73278fbe7eeb5391a9e1cb57e69f.svg";